export const countryOptions = [
  { value: 1, label: "Mundo" },
  { value: 23424975, label: "Inglaterra" },
  { value: 23424768, label: "Brasil" },
  { value: 23424829, label: "Alemanha" },
  { value: 23424900, label: "Mexico" },
  { value: 23424775, label: "Canada" },
  { value: 23424977, label: "Estados Unidos" },
]
